import { render, staticRenderFns } from "./IndustryTab.vue?vue&type=template&id=1321eb36"
import script from "./IndustryTab.vue?vue&type=script&lang=js"
export * from "./IndustryTab.vue?vue&type=script&lang=js"
import style0 from "./IndustryTab.vue?vue&type=style&index=0&id=1321eb36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports